import { EventBus } from 'cadenza/utils/event-bus';
import { assertType } from 'cadenza/utils/custom-error';
import { ModifyEventType } from 'cadenza/map/interactions/modify-interaction';
import { DRAW_INTERACTION_EVENT } from 'cadenza/map/interactions/draw-interaction';
import type { EditableGeometryType, EditablePolygonVariantType } from 'cadenza/workbook/editable-geometry-type';

export interface ActivateDrawInteractionEventDetails {
  drawMode: EditableGeometryType | EditablePolygonVariantType;
}

export const FeatureGeometryEditorEvent = {
  ACTIVATE_DRAW_INTERACTION: 'ACTIVATE_DRAW_INTERACTION',
  ACTIVATE_SELECT_INTERACTION: 'ACTIVATE_SELECT_INTERACTION',
  INTERACTION_FINISHED: 'INTERACTION_FINISHED',
  INTERACTION_FAILED: 'INTERACTION_FAILED',
  ADD_DRAW_LAYER: 'ADD_DRAW_LAYER',
  CHANGE_POLYGON_MERGE_STRATEGY: 'CHANGE_POLYGON_MERGE_STRATEGY',
  CHANGE: 'CHANGE',
  CLEAN_DRAW_LAYER: 'CLEAN_DRAW_LAYER',
  DELETE_SELECTED_FEATURES: 'DELETE_SELECTED_FEATURES',
  DEACTIVATED_DRAW_INTERACTION: 'DEACTIVATED_DRAW_INTERACTION',
  REDO: 'REDO',
  REMOVE_DRAW_LAYER: 'REMOVE_DRAW_LAYER',
  SNAPPING_SETTINGS_CHANGE: 'SNAPPING_SETTINGS_CHANGE',
  UNDO: 'UNDO',
  UNDO_REDO_EVENT: 'UNDO_REDO_EVENT'
};

type FeatureGeometryEditorEventType = keyof typeof FeatureGeometryEditorEvent;

export class FeatureGeometryEditorEventBus extends EventBus {

  constructor () {
    super('cadenza/feature-geometry-editor/event-bus');
  }

  trigger (eventType: string, detail?: object): void {
    eventTypeInAllowedEventTypes(eventType);
    this.dispatchEvent(new CustomEvent(eventType, { detail }));
  }

}

function eventTypeInAllowedEventTypes (eventType: string) {
  assertType<FeatureGeometryEditorEventType>(
    eventType,
    eventType in FeatureGeometryEditorEvent
    || Object.values(ModifyEventType).includes(eventType)
    || Object.values(DRAW_INTERACTION_EVENT).includes(eventType));
}
